import script from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./CompanySwitcher.vue?vue&type=style&index=0&id=13ded165&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ded165"]])

export default __exports__